!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.my = t());
}(this, function () {
  "use strict";

  return [{
    locale: "my",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      return "other";
    },
    fields: {
      year: {
        displayName: "နှစ်",
        relative: {
          0: "ယခုနှစ်",
          1: "လာမည့်နှစ်",
          "-1": "ယမန်နှစ်"
        },
        relativeTime: {
          future: {
            other: "{0} နှစ်အတွင်း"
          },
          past: {
            other: "ပြီးခဲ့သည့် {0} နှစ်"
          }
        }
      },
      month: {
        displayName: "လ",
        relative: {
          0: "ယခုလ",
          1: "လာမည့်လ",
          "-1": "ပြီးခဲ့သည့်လ"
        },
        relativeTime: {
          future: {
            other: "{0} လအတွင်း"
          },
          past: {
            other: "ပြီးခဲ့သည့် {0} လ"
          }
        }
      },
      day: {
        displayName: "ရက်",
        relative: {
          0: "ယနေ့",
          1: "မနက်ဖြန်",
          2: "သန်ဘက်ခါ",
          "-2": "တစ်နေ့က",
          "-1": "မနေ့က"
        },
        relativeTime: {
          future: {
            other: "{0} ရက်အတွင်း"
          },
          past: {
            other: "ပြီးခဲ့သည့် {0} ရက်"
          }
        }
      },
      hour: {
        displayName: "နာရီ",
        relative: {
          0: "ဤအချိန်"
        },
        relativeTime: {
          future: {
            other: "{0} နာရီအတွင်း"
          },
          past: {
            other: "ပြီးခဲ့သည့် {0} နာရီ"
          }
        }
      },
      minute: {
        displayName: "မိနစ်",
        relative: {
          0: "ဤမိနစ်"
        },
        relativeTime: {
          future: {
            other: "{0} မိနစ်အတွင်း"
          },
          past: {
            other: "ပြီးခဲ့သည့် {0} မိနစ်"
          }
        }
      },
      second: {
        displayName: "စက္ကန့်",
        relative: {
          0: "ယခု"
        },
        relativeTime: {
          future: {
            other: "{0} စက္ကန့်အတွင်း"
          },
          past: {
            other: "ပြီးခဲ့သည့် {0} စက္ကန့်"
          }
        }
      }
    }
  }];
});